import React from 'react';
import { Dialog } from 'wix-ui-tpa/cssVars';
import { SimpleGallery } from '../SimpleGallery/SimpleGallery';
import { dataHooks } from '../../dataHooks';
import { SimpleGalleryModalLogic } from './SimpleGalleryModalLogic';
export const SimpleGalleryModal = _ref => {
  let {
    images,
    isOpen,
    setIsOpen,
    dataHook,
    isMobile,
    biFunctions,
    closeButtonAriaLabel,
    nextButtonAriaLabel,
    previousButtonAriaLabel
  } = _ref;
  const {
    dialogContentWrapperClassName,
    dialogContentClassName,
    onCloseModal
  } = SimpleGalleryModalLogic({
    isMobile,
    biFunctions,
    setIsOpen
  });
  return /*#__PURE__*/React.createElement(Dialog, {
    childrenWrapperClassName: dialogContentClassName,
    closeButtonAriaLabel: closeButtonAriaLabel,
    contentClassName: dialogContentWrapperClassName,
    isOpen: isOpen,
    onClose: onCloseModal,
    "data-hook": dataHooks.gallery.modal(dataHook ?? '')
  }, /*#__PURE__*/React.createElement(SimpleGallery, {
    currentImageIndex: 0,
    dataHook: dataHook,
    images: images,
    biFunctions: biFunctions,
    nextButtonAriaLabel: nextButtonAriaLabel,
    previousButtonAriaLabel: previousButtonAriaLabel
  }));
};
//# sourceMappingURL=SimpleGalleryModal.js.map